import React, { Component } from 'react';
import {http} from '../misc/http';
import {isEmail} from 'validator';
import Layout from '../layout/Auth';
import profile from '../assets/profile.png';
import {Link} from 'react-router-dom';

export default class Login extends Component {
  state={
    email: '',
    disabled: true
  }
  
  handleForgot = async () => {
    let params = {
      method:'POST',
      path:'auth/resetPassword/request',
      data:{email: this.state.email},
      showMessage: false
    }
    let {data} = await http(params);
    if (data.status === true && data.code === 200) {
      this.resetForm();
      this.props.history.push('/login');
      window.location.reload()
    }
    alert(data.message)
  }

  validate = () => {
    let {email, disabled} = this.state;
    if (isEmail(email)) disabled = false
    else disabled = true;
    this.setState({disabled})
  }
  
  handleOnChange = async ({target: {name, value}}) => {
    await this.setState({email: value});
    this.validate()
  }

  resetForm = () => {
    this.setState({email: ''})
  }

  render() {
    return (
      <Layout>
        <div className="card card-primary card-auth" style={{borderRadius: '0px'}}>
          <div className="card-body text-center">
            <p className="mb-4" style={{fontSize: '25px', fontWeight: '600'}}>Silahkan Masukan Email Anda</p><br/>
            <div className="auth" action="">
              <div className="input-group mb-3">
                <div className="input-group-prepend"><span className="input-group-text" id="basic-addon1"><img src={profile} alt="profile" style={{width: '20px',height: '20px'}} /></span></div>
                <input className="form-control" type="email" placeholder="Alamat Email Anda" name="email" onChange={(e) => this.handleOnChange(e)} />
              </div>
              <button className="btn btn-blue w-100 mt-4" style={{padding: '14px 25px !important', background: '#005097'}}     disabled={this.state.disabled} onClick={() => this.handleForgot()}>Kirim</button>
            </div>
            <p className="mt-4" style={{fontSize: '13px'}}>Sudah memiliki akun? <Link to='/login' style={{color: '#005097'}}>Masuk Disini</Link></p>
          </div>
        </div>
      </Layout>
    )
  }
}
